export default {
  add_items: 'Ajouter des articles',
  remove_items: 'Retirer des articles',
  place_order: 'Passer la commande',
  proceed_to_payment: 'Continuer vers le paiement',
  go_to_menu: 'Aller au menu',

  toasts: {
    input_errors_found: 'Des erreurs ont été trouvées dans vos informations de commande',
  },

  error_messages: {
    internal_error: {
      title: 'Commande échouée 😔',
      description:
        "Malheureusement, un problème inattendu est survenu avec votre commande, notre équipe technique s'en occupe déjà 🛠️.",
    },
  },
};
